import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block3-左翻.png")